const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContigencyPlan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 18 18",
    fill: "#2A547C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A547C"
    },
    d: "M19.493 19.9993H0.506268C0.226729 19.9993 0 19.7724 0 19.4931C0 18.7212 0.300199 17.9974 0.845498 17.4556C1.38517 16.9122 2.10794 16.6121 2.87839 16.6121H8.81265C9.09219 16.6121 9.31892 16.839 9.31892 17.1183C9.31892 17.3979 9.092 17.6246 8.81265 17.6246L2.87839 17.6248C2.37972 17.6248 1.9121 17.819 1.56139 18.1717C1.3297 18.4018 1.16671 18.6813 1.08143 18.9868H18.9172C18.6961 18.2017 17.9747 17.6248 17.1212 17.6248H11.1873C10.9078 17.6248 10.6811 17.3979 10.6811 17.1185C10.6811 16.839 10.908 16.6122 11.1873 16.6122H17.1216C18.7089 16.6122 20 17.9047 20 19.4931C19.9998 19.7727 19.7731 19.9994 19.4936 19.9994L19.493 19.9993Z",
    fill: "#DC9023"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A547C"
    },
    d: "M14.1122 17.6251C13.9376 17.6251 13.7673 17.5345 13.6736 17.3722C12.9171 16.0649 11.5097 15.2528 10.0004 15.2528C8.49105 15.2528 7.08364 16.0649 6.32733 17.3722C6.1873 17.6143 5.87774 17.6973 5.63563 17.5567C5.39352 17.4167 5.31088 17.1071 5.45109 16.865C6.38755 15.2459 8.1308 14.2402 10.0002 14.2402C11.8697 14.2402 13.613 15.2461 14.5498 16.8652C14.6898 17.1073 14.6072 17.4169 14.3653 17.5569C14.2856 17.6032 14.1982 17.6251 14.1122 17.6251H14.1122Z",
    fill: "#DC9023"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A547C"
    },
    d: "M9.99846 15.2525C9.71892 15.2525 9.49219 15.0256 9.49219 14.7462V5.25285C9.49219 4.97331 9.7191 4.74658 9.99846 4.74658C10.278 4.74658 10.5047 4.9735 10.5047 5.25285V14.7462C10.5047 15.0258 10.278 15.2525 9.99846 15.2525Z",
    fill: "#DC9023"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A547C"
    },
    d: "M9.84277 12.8793H7.6257C6.03783 12.8793 4.74609 11.5874 4.74609 9.99968C4.74609 9.72014 4.97301 9.49341 5.25236 9.49341H7.46943C9.0573 9.49341 10.349 10.7853 10.349 12.373C10.3492 12.6526 10.1223 12.8793 9.84277 12.8793ZM5.8282 10.5059C6.04946 11.2902 6.77153 11.8668 7.6257 11.8668H9.26675C9.04548 11.0825 8.32342 10.5059 7.46943 10.5059H5.8282Z",
    fill: "#DC9023"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A547C"
    },
    d: "M10.0013 5.75927H7.628C4.73162 5.75927 2.375 3.4027 2.375 0.506268C2.375 0.226729 2.60191 0 2.88127 0H5.25461C8.15099 0 10.5076 2.35657 10.5076 5.253C10.5076 5.53254 10.2809 5.75927 10.0013 5.75927ZM3.41791 1.01258C3.66885 3.1131 5.46138 4.74673 7.62813 4.74673H9.46501C9.21425 2.64621 7.4219 1.01258 5.25479 1.01258H3.41791Z",
    fill: "#DC9023"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A547C"
    },
    d: "M9.99951 5.75942C9.90309 5.75942 9.80526 5.73205 9.71927 5.67431L6.15907 3.30097C5.92651 3.14575 5.86364 2.83159 6.01851 2.59905C6.17373 2.36666 6.48807 2.30344 6.72043 2.45848L10.2806 4.83182C10.5132 4.98704 10.5761 5.3012 10.4212 5.53374C10.3239 5.68049 10.1634 5.75942 9.9995 5.75942H9.99951Z",
    fill: "#DC9023"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A547C"
    },
    d: "M12.3718 5.75927H9.99846C9.71892 5.75927 9.49219 5.53235 9.49219 5.253C9.49219 2.35662 11.8488 0 14.7452 0H17.1185C17.3981 0 17.6248 0.226914 17.6248 0.506268C17.6248 3.40265 15.2682 5.75927 12.3718 5.75927ZM10.5349 4.74673H12.3718C14.5389 4.74673 16.3313 3.1131 16.582 1.01258H14.7451C12.578 1.01258 10.7857 2.64621 10.5349 4.74673Z",
    fill: "#DC9023"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A547C"
    },
    d: "M9.99899 5.7593C9.83547 5.7593 9.67478 5.68001 9.5773 5.53379C9.42208 5.30123 9.48512 4.9867 9.71787 4.83187L13.2781 2.45853C13.5106 2.30313 13.8252 2.36617 13.98 2.59909C14.1352 2.83166 14.0722 3.14618 13.8394 3.30102L10.2792 5.67436C10.1931 5.73193 10.0954 5.7593 9.99898 5.7593H9.99899Z",
    fill: "#DC9023"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A547C"
    },
    d: "M12.2155 12.8793H9.99846C9.71892 12.8793 9.49219 12.6524 9.49219 12.373C9.49219 10.7851 10.7839 9.49341 12.3718 9.49341H14.5889C14.8684 9.49341 15.0951 9.72032 15.0951 9.99968C15.0953 11.5876 13.8034 12.8793 12.2155 12.8793ZM10.5743 11.8668H12.2153C13.0695 11.8668 13.7916 11.2904 14.0128 10.5059H12.3718C11.5176 10.5059 10.7956 11.0825 10.5743 11.8668Z",
    fill: "#DC9023"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContigencyPlan);
export default __webpack_public_path__ + "static/media/contigencyPlan.532f9005.svg";
export { ForwardRef as ReactComponent };